<div class="saml-callback-container" style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:40vh;gap:1rem;">
  <div *ngIf="loading">
    Completing SAML sign-in…
  </div>

  <div *ngIf="!loading && !errorMessage && availableScopes.length">
    <h3>You're signed in. Choose the account to continue with.</h3>
    <div style="display:flex;flex-direction:column;gap:0.75rem;margin-top:1rem;">
      <button
        type="button"
        class="btn btn-primary"
        *ngFor="let scope of availableScopes"
        [disabled]="selectingScope"
        (click)="onScopeSelected(scope)">
        Continue as {{ scopeLabel(scope) }}
      </button>
    </div>
  </div>

  <div *ngIf="!loading && errorMessage" style="display:flex;flex-direction:column;align-items:center;gap:0.75rem;">
    <div class="text-danger">{{ errorMessage }}</div>
    <button type="button" class="btn btn-secondary" (click)="backToLogin()">Back to login</button>
  </div>
</div>
